import { render } from "./NewProductUpdateModal.vue?vue&type=template&id=47313e31"
import script from "./NewProductUpdateModal.vue?vue&type=script&lang=js"
export * from "./NewProductUpdateModal.vue?vue&type=script&lang=js"
script.render = render

export default script